export default "__VITE_ASSET__CF84rQFu__"